import {
    getDescription,
    getOrigin,
    //getIssueNoteText,
    getCriticalityList,
    getCriticalityOrUnknown,
    getStatus,
    getStatusList,
    getEvaluationOpt,
    getEvaluationNames,
    getUserFromIssue,
    getMapillaryKey,
    getExternalIssue,
} from 'qa/src/queries/qa';

import {
    A,
    DIV,
    IMG,
    NodeOrOptional,
    NODISPLAY,
    SPAN,
} from 'sdi/components/elements';
import tr, { formatDate } from 'sdi/locale';
import debug = require('debug');
import { QaMessageKey } from 'qa/src/locale';
import { fromNullable } from 'fp-ts/lib/Option';
import { Issue } from 'qa/src/remote';
import { renderListSelecter } from '../list-selecter';
import { setCollapsible } from 'qa/src/events/app';

//import { renderLinkedIssues } from './linked-issues';
import {
    changeCriticality,
    changeEvaluation,
    //changeIssueNoteText,
    changeStatus,
    //deleteIssueNoteText,
} from 'qa/src/events/qa';
//import { renderEditableText } from '../editable-text';
import { ExCo } from '.';
import { getCollapsible } from 'qa/src/queries/app';
import { renderSubButtonCollapse, renderSubButtonExpand } from '../buttons';
import { renderTagWrapper } from './tags';
import { isUserLogged } from 'sdi/app';

// import { openTagsEditor } from 'qa/src/events/app';

const logger = debug('client:issue-info');

// Default wrapper for subsections
const renderSubWrapper = (
    name: string,
    header: NodeOrOptional,
    body: NodeOrOptional[],
    [onExpand, onCollapse] = [() => {}, () => {}] as ExCo
) => {
    const collapsed = getCollapsible(name) ? 'expended' : 'collapsed';
    return DIV(
        { className: `sidebar-subitem ${name} active` },
        DIV(
            {
                className: `sidebar-subitem__header ${collapsed}`,
                onClick: () => {
                    if (getCollapsible(name)) {
                        setCollapsible(name, false);
                        onCollapse();
                    } else {
                        setCollapsible(name, true);
                        onExpand();
                    }
                },
            },
            header,
            getCollapsible(name)
                ? renderSubButtonCollapse(() => {
                      setCollapsible(name, false);
                      onCollapse();
                  })
                : renderSubButtonExpand(() => {
                      setCollapsible(name, true);
                      onExpand();
                  })
        ),
        getCollapsible(name)
            ? DIV({ className: 'sidebar-subitem__body' }, body)
            : NODISPLAY()
    );
};

const renderInfoUnit = (title: QaMessageKey, value: NodeOrOptional) =>
    DIV(
        { className: `issue-field ${title}`, key: `issue-field-${title}` },
        DIV({ className: 'issue-field-label' }, tr.qa(title)),
        DIV(
            {
                className: 'issue-field-value',
            },
            value
        )
    );
const renderInfoUnitTranslated = (title: QaMessageKey, value: QaMessageKey) =>
    DIV(
        { className: `issue-field ${title}`, key: `issue-field-${title}` },
        DIV({ className: 'issue-field-label' }, tr.qa(title)),
        DIV(
            {
                className: 'issue-field-value',
            },
            tr.qa(value)
        )
    );

const renderInfoUnitLinked = (i: Issue) =>
    DIV(
        { className: `issue-field OSMObject`, key: `issue-field-OSMObject` },
        DIV({ className: 'issue-field-label' }, tr.qa('OSMObject')),
        DIV(
            { className: 'issue-field-value' },
            A(
                {
                    className: 'link-simple',
                    href: `https://www.openstreetmap.org/${i.osm_type}/${i.osm_id}/`,
                    target: '_blank',
                },
                `${i.osm_type}/${i.osm_id} (v${i.osm_version})`
            ),
            SPAN('', ' '),
            A(
                {
                    className: 'link-history',
                    href: `https://www.openstreetmap.org/${i.osm_type}/${i.osm_id}/history/`,
                    target: '_blank',
                },
                '(history)'
            )
        )
    );

// const renderEditableUnit = (title: QaMessageKey, value: NodeOrOptional) =>
//     DIV(
//         { className: `issue-field note`, key: `issue-field-${title}` },
//         DIV({ className: 'issue-field-label' }, tr.qa(title)),
//         DIV(
//             {
//                 className: 'issue-field-value',
//             },
//             value
//         )
//     );

const renderAchaviLink = (i: Issue) =>
    SPAN(
        {},
        A(
            {
                className: 'link-qa achavi',
                href: `https://overpass-api.de/achavi/?changeset=${i.changeset_id}/`,
                target: '_blank',
            },
            'Achavi'
        )
    );

const renderOsmchaLink = (i: Issue) =>
    SPAN(
        {},
        A(
            {
                className: 'link-qa osmcha',
                href: `https://osmcha.org/changesets/${i.changeset_id}/`,
                target: '_blank',
            },
            'OsmCha'
        )
    );

const renderLoipeHistoryLink = (i: Issue) =>
    SPAN(
        {},
        A(
            {
                className: 'link-qa loipe-history',
                href: `https://osm.virtuelle-loipe.de/history/?type=${i.osm_type}&ref=${i.osm_id}/`,
                target: '_blank',
            },
            'HistoryBrowser'
        )
    );

const renderLinkList = (i: Issue) =>
    DIV(
        { className: `issue-field links` },
        DIV({ className: 'issue-field-label' }, 'Liens'),
        DIV(
            { className: 'issue-field-value' },
            DIV(
                { className: 'value link' },
                renderAchaviLink(i),
                renderOsmchaLink(i),
                renderLoipeHistoryLink(i)
            )
        )
    );

const renderUserInfo = (issue: Issue) =>
    DIV(
        {
            className: `issue-field contributor`,
            key: `issue-field-contributor`,
        },
        DIV({ className: 'issue-field-label' }, tr.qa('contributor')),
        DIV(
            { className: 'issue-field-value' },
            A(
                {
                    className: 'link-qa',
                    href: `https://www.openstreetmap.org/user/${issue.osm_user}`,
                    target: '_blank',
                },
                issue.osm_user
            )
            //renderEvaluation(issue)
        )
    );

const renderGeneralInfo = (issue: Issue) =>
    renderSubWrapper('general-informations', `${tr.qa('generalInfo')}`, [
        getOrigin(issue.issue_type).map(o =>
            renderInfoUnitTranslated('origin', o)
        ),
    ]);

const renderMapillary = (issue: Issue) => {
    const coord = issue.point.coordinates;
    return DIV(
        {
            className: 'mapillary',
        },
        getMapillaryKey(issue.id).map(key =>
            IMG({
                className: 'img',
                src: `https://images.mapillary.com/${key}/thumb-640.jpg`,
            })
        ),
        A(
            {
                className: 'link-qa',
                href: `https://www.mapillary.com/app/?lat=${coord[1]}&lng=${coord[0]}&z=18`,
                target: '_blank',
            },
            `${tr.qa('viewOnMapillary')}`
        )
    );
};

const renderPanoramax = (issue: Issue) => {
    const coord = issue.point.coordinates;
    return DIV(
        {
            className: 'panoramax',
        },
        A(
            {
                className: 'link-qa',
                href: `https://api.panoramax.xyz/?focus=map&map=18/${coord[1]}/${coord[0]}`,
                target: '_blank',
            },
            `${tr.qa('viewOnPanoramax')}`
        )
    );
};

export const renderIssueDate = (issue: Issue) => {
    const date = Date.parse(issue.timestamp);
    return DIV({ className: 'issue__date' }, formatDate(new Date(date)));
};

const renderIssueStatus = (i: Issue) =>
    DIV('issue__status', tr.qa(getStatus(i)));

export const renderStatus = (i: Issue) =>
    isUserLogged()
        ? renderListSelecter(
              'status',
              getStatus(i),
              getStatusList(),
              changeStatus(i)
          )
        : renderIssueStatus(i);

const renderIssueCriticality = (i: Issue) =>
    DIV('issue__criticality', tr.qa(getCriticalityOrUnknown(i)));

export const renderCriticality = (i: Issue) =>
    isUserLogged()
        ? renderListSelecter(
              'criticality',
              getCriticalityOrUnknown(i),
              getCriticalityList(),
              changeCriticality(i)
          )
        : renderIssueCriticality(i);

export const renderEvaluation = (i: Issue) => {
    const current = getEvaluationOpt(i.osm_user).getOrElse('NONE');
    return getUserFromIssue(i).map(user =>
        renderListSelecter(
            'evaluation',
            current,
            getEvaluationNames(),
            changeEvaluation(user)
        )
    );
};

// const renderResolvingChangesetInfo = (issue: Issue) =>
//     renderResolvingChangeset(
//         'resolvingChangeset',
//         issue,
//         createResolvingChangeset,
//     );

const renderBooleanInfo = (title: QaMessageKey, b: boolean) =>
    b
        ? DIV(
              {
                  className: `issue-field ${title}`,
                  key: `issue-field-${title}`,
              },
              DIV({ className: 'issue-field-label' }, tr.qa('reported_info')),
              DIV({ className: 'issue-field-value' }, tr.qa(title))
          )
        : NODISPLAY();

const renderExternalInfo = () =>
    getExternalIssue().map(ei =>
        DIV(
            {},
            renderInfoUnit(
                'external_date',
                formatDate(new Date(Date.parse(ei.creation_date)))
            ),
            ei.new_name !== ''
                ? renderInfoUnit('newName', ei.new_name)
                : NODISPLAY(),
            renderBooleanInfo('temporary_closed', ei.temporary_closed),
            renderBooleanInfo('definitely_closed', ei.definitely_closed),
            renderBooleanInfo('wheelchairaccessible', ei.wheelchairaccessible),
            renderBooleanInfo('is_not_present', ei.is_not_present),
            renderInfoUnit('comment', ei.comment)
        )
    );

const renderDetailedInfo = (issue: Issue) =>
    renderSubWrapper('detailed-informations', `${tr.qa('detailedInfo')}`, [
        renderInfoUnit('description', getDescription(issue.issue_type)),
        fromNullable(issue.origin).map(origin =>
            renderInfoUnit('origin', tr.qa(origin))
        ),
        renderExternalInfo(),
        fromNullable(issue.osm_id).map(_id =>
            DIV(
                {},
                renderInfoUnitLinked(issue),
                renderLinkList(issue),
                renderTagWrapper(issue),
                renderUserInfo(issue)
            )
        ),
        // renderResolvingChangesetInfo(issue)
    ]);

const renderAdditionalInfo = (issue: Issue) =>
    renderSubWrapper('additional-informations', `${tr.qa('additionalInfo')}`, [
        // renderEditableUnit(
        //     'notes',
        //     renderEditableText(
        //         'notes',
        //         issue,
        //         changeIssueNoteText,
        //         getIssueNoteText,
        //         deleteIssueNoteText
        //     )
        // ),
        // renderLinkedIssues(issue),
        renderMapillary(issue),
        renderPanoramax(issue),
    ]);

export const renderIssueInfo = (issue: Issue) => {
    return DIV(
        { className: 'issue-info-page' },
        renderGeneralInfo(issue),
        renderDetailedInfo(issue),
        renderAdditionalInfo(issue)
    );
};

logger('loaded');
